import { CSSProperties } from 'react'

export const s = {
  root: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  } as CSSProperties,
  title: {
    paddingLeft: 12,
    display: 'flex',
    flexDirection: 'column',
  } as CSSProperties,
  timeCompleted: {
    fontSize: 14,
  } as CSSProperties,
}
